module.exports = __webpack_public_path__ + "static/img/item02.57276288.png";